export default __webpack_public_path__ + "static/media/left-arrow-white.a7968dae.svg";